module.exports = __webpack_public_path__ + "static/img/wealth_level_52.8e91380.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_52.png
// module id = 7uR9
// module chunks = 0